import * as React from "react";
import { NavLink } from "react-router-dom";
import FindJob from "./FindJob";
import { clientUrlPrefix } from "../settings";

interface INavProps {
    menu: Array<{
        target: string,
        text: string,
        onClick? (): void,
    }>,
};

const Nav = (props: INavProps) => (
    <nav className="ll-nav">
        <ul>
            {props.menu.map(item => (
                <li key={item.target}>
                    <NavLink
                        to={item.target}
                        exact={item.target === clientUrlPrefix+"/"}
                        activeClassName="ll-active"
                        onClick={item.onClick}
                    >
                        {item.text}
                    </NavLink>
                </li>
            ))}
        </ul>

        <FindJob />

    </nav>
);

export default Nav;
